export default {
    formatCotacao: (cotacao: number, prefixado: number = null, unidade: String = null, minimumFractionDigits = 2, maximumFractionDigits = 4) =>{
        let formatter = new Intl.NumberFormat('pt-br', {
            minimumFractionDigits,
            maximumFractionDigits
        });
        let cotacaoAux = formatter.format(cotacao);
        cotacaoAux = cotacaoAux.indexOf(",") >= 0 ? cotacaoAux : cotacaoAux + ",00"
        unidade = unidade ? unidade : ""
        return (prefixado ? unidade : "") + " " + cotacaoAux + " " + (!prefixado ? unidade : "")
    },
    formatVariacao: (variacao: number, incluirSinal = true, minimumFractionDigits = 2) => {
        let formatter = new Intl.NumberFormat('pt-br', {
            minimumFractionDigits,
            maximumFractionDigits: 2
        });
        let variacaoAux = formatter.format(variacao);
        let sinal = incluirSinal ? (variacao > 0 ? "+" : "") : "";
        return sinal + variacaoAux + "%"
    }
}